export default {"src":"/_next/static/image/components/ui/Icon/icons/facebook.001ce7d17c2752306353f1a14f528fe1.svg","height":15,"width":8};